module.exports = __webpack_public_path__ + "img/maker-0.4bd2d846.jpg";